import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  IconButton,
  Modal,
  Typography,
} from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { IoIosCopy } from 'react-icons/io';
import { MdOutlineDone } from 'react-icons/md';
import CustomInput from '../../../Components/Custom/CustomInput';
import { modalStyle } from '../utils';

/**
 * Share modal component for sharing restaurant links
 * @param {Object} props - Component props
 * @param {boolean} props.open - Modal open state
 * @param {Function} props.onClose - Close handler
 * @param {string} props.restaurantName - Restaurant name
 * @param {string} props.restaurantId - Restaurant ID for URL
 */
const ShareModal = ({ open, onClose, restaurantName, restaurantId }) => {
  const [copied, setCopied] = useState(false);
  const shareUrl = `https://www.reisty.com/restaurant/${restaurantId}`;

  const handleCopy = () => {
    navigator.clipboard
      .writeText(shareUrl)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch((err) => console.error('Failed to copy:', err));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="share-modal-title"
      aria-describedby="share-modal-description"
    >
      <Box sx={modalStyle}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Box>
            <Typography 
              id="share-modal-title"
              sx={{ fontWeight: 700, fontSize: '16px' }}
            >
              Share link
            </Typography>
            <Typography 
              id="share-modal-description"
              sx={{ fontSize: '12px' }}
            >
              Recommend <b>{restaurantName}</b> to a friend.
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseOutlined />
          </IconButton>
        </Box>

        <Box sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
          <CustomInput
            size="small"
            fullWidth
            value={shareUrl}
            readOnly
          />
          <IconButton onClick={handleCopy}>
            {copied ? <MdOutlineDone /> : <IoIosCopy />}
          </IconButton>
        </Box>
      </Box>
    </Modal>
  );
};

ShareModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  restaurantName: PropTypes.string,
  restaurantId: PropTypes.string.isRequired,
};

export default ShareModal;
